import React, { useState, useEffect } from "react";
import Header from "./Header";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Helmet } from "react-helmet-async";
import "../index.css";
export default function Main() {
  const [showPopup, setShowPopup] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
    };

    // Check for saved theme preference
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      setIsDarkMode(true);
      document.body.classList.add("dark-theme");
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.body.classList.add("dark-theme");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark-theme");
      localStorage.setItem("theme", "light");
    }
  };

  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = "unset";
  };

  return (
    <div className={`app ${isDarkMode ? "dark-theme" : ""}`}>
      <Helmet>
        <title>Vermutería Xarel·lo</title>
        <meta name="description" content="Una vermuteria davant del Passeig del Mar a Palamós" />
        <link rel="canonical" href="/" />
      </Helmet>
      <Header
        isScrolled={isScrolled}
        isDarkMode={isDarkMode}
        toggleTheme={toggleTheme}
      />
      <main className="main-content">
        <section
          id="home"
          className="hero-section"
          style={{
            background: `linear-gradient(var(--hero-overlay-start), var(--hero-overlay-end)), url('/img/mainBg.png')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
          }}
        >
          <div className="hero-content">
            <title>Vermutería Xarel·lo</title>
            <h1 className="main-title">Vermutería Xarel·lo</h1>
            <p className="tagline">
              "Un aperitiu sense vermut, és com un dia d'estiu sense sol,
              impossible de passar."☀️🍸
            </p>
            <div className="schedule-container">
              <h2 className="schedule-title">HORARI</h2>
              <div className="schedule-item">
                <div className="schedule-row">
                  <span className="schedule-day">DE DILLUNS A DISSABTE</span>
                  <div className="schedule-times">
                    <span>11:00h - 14:30h</span>
                    <span>17:30h - 20:30h</span>
                  </div>
                </div>
              </div>
              <div className="schedule-item">
                <div className="schedule-row">
                  <span className="schedule-day">DIUMENGE</span>
                  <span className="schedule-time">11:00h - 14:30h</span>
                </div>
              </div>
              <div className="schedule-item closed">
                <span className="schedule-day">DIMARTS TARDA I DIMECRES TANCAT</span>
              </div>
            </div>
          </div>
        </section>

        <section id="menu" className="section menu-section">
          <div className="section-content">
            <h2>La nostra carta</h2>
            <div className="menu-columns">
              <div className="menu-column">
                <div
                  className="menu-image-container"
                  onClick={() => openModal("/img/2.png")}
                >
                  <img
                    src="/img/2.png"
                    alt="Carta de menjars"
                    className="menu-image"
                  />
                  <div className="image-overlay">
                    <span>Click per veure la carta completa</span>
                  </div>
                </div>
              </div>
              <div className="menu-column">
                <div
                  className="menu-image-container"
                  onClick={() => openModal("/img/1.png")}
                >
                  <img
                    src="/img/1.png"
                    alt="Carta de begudes"
                    className="menu-image"
                  />
                  <div className="image-overlay">
                    <span>Click per veure la carta completa</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-section">
              <Carousel
                className="carousel-root"
                infiniteLoop="true"
                autoPlay="true"
                interval="3000"
              >
                <div>
                  <img
                    src="/img/carrouselImg/07.jpg"
                    alt=""
                    className="imgCarrousel"
                  />
                  <p className="legend">
                    Llom, fuet i un Vermut de la casa
                  </p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/09.jpg"
                    alt=""
                    className="imgCarrousel"
                  />
                  <p className="legend">Gildes picants d'anxoves</p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/10.jpg"
                    alt=""
                    className="imgCarrousel"
                  />
                  <p className="legend">
                    Pernil cebo de campo siguent tallat a mà
                  </p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/01.png"
                    alt=""
                    className="imgCarrousel"
                  />
                  <p className="legend">
                    Musclos amb el toc de la casa
                  </p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/03.png"
                    alt=""
                    className="imgCarrousel"
                  />{" "}
                  <p className="legend">Llonganissa de llobach</p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/04.png"
                    alt=""
                    className="imgCarrousel"
                  />{" "}
                  <p className="legend">
                    Vermut de la casa amb olives i un assortit N1{" "}
                  </p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/05.png"
                    alt=""
                    className="imgCarrousel"
                  />{" "}
                  <p className="legend">Gildes normals i picants</p>
                </div>
                <div>
                  <img
                    src="/img/carrouselImg/06.png"
                    alt=""
                    className="imgCarrousel"
                  />{" "}
                  <p className="legend">
                    Olives farcides alinyades picants
                  </p>
                </div>
              </Carousel>
            </div>
          </div>
        </section>

        {/* <section id="menu" className="section menu-section">
                <div className="section-content">
                  <h2>Altres serveis</h2>
                  <div className="menu-columns">
                    <div className="menu-column">
                      <h3> Botiga </h3>
                      <div
                        className="menu-image-container"
                        onClick={() => openModal("/img/2.png")}
                      >
                        <img
                          src="/img/2.png"
                          alt="Carta de menjars"
                          className="menu-image"
                        />
                        <div className="image-overlay">
                          <span>Click per veure la carta completa</span>
                        </div>
                      </div>
                    </div>
                    <div className="menu-column">
                      <h3> Vins a granel </h3>
                      <div
                        className="menu-image-container"
                        onClick={() => openModal("/img/1.png")}
                      >
                        <img
                          src="/img/1.png"
                          alt="Carta de begudes"
                          className="menu-image"
                        />
                        <div className="image-overlay">
                          <span>Click per veure la carta completa</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section> */}
        <section id="contact" className="section contact-section">
          <div className="section-content">
            <h2 className="contact-title">Contacte</h2>
            <div className="contact-info">
              <p>
                📍 Direcció:&nbsp;
                <a
                  href="https://www.google.es/maps/place/Vermuteria+Xarel%E2%80%A2lo/@41.8472769,3.1264873,17.25z/data=!4m6!3m5!1s0x12bbaaee36a79f63:0xbc44f6dd3ae9c581!8m2!3d41.8484788!4d3.1250149!16s%2Fg%2F11c55kb2pv?entry=ttu&g_ep=EgoyMDI1MDUxMy4xIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Passeig del mar n9
                </a>
              </p>
              <p>📞 Teléfono: 972 31 79 13</p>
              <p> ✉️ Email: mmas291104@gmail.com </p>
              <p>
                📸 Instagram:&nbsp;
                <a
                  href="https://www.instagram.com/vermuteriaxarel.lo/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @vermuteriaxarel.lo
                </a>
              </p>
              <p> </p>
            </div>
          </div>
        </section>
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup">
              <button
                className="popup-close"
                onClick={() => setShowPopup(false)}
              >
                ×
              </button>

              <h2>Tancat per descans del personal</h2>

              <p>
                31 - 01 - 02 Setembre
              </p>

              <button
                className="popup-button"
                onClick={() => setShowPopup(false)}
              >
                Entrar
              </button>
            </div>
          </div>
        )}
        {selectedImage && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeModal}>
                ×
              </button>
              <img
                src={selectedImage}
                alt="Carta completa"
                className="modal-image"
              />
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
